<h2 mat-dialog-title>{{ title | translate }}</h2>
<div *ngIf="!formGroup">
  <mat-spinner></mat-spinner>
</div>
<form *ngIf="formGroup"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit()">
  <mat-dialog-content>

    <div class="form-group" *ngFor="let fControl of Object.keys(formGroup.controls)">

      <div *ngIf="title == 'changePassword'">
        <mat-form-field appearance="outline">
          <mat-label>{{ fControl | translate }}</mat-label>
          <input matInput
                 autofocus
                 required
                 [type]="hide ? 'password' : 'text'"
                 autocomplete="off"
                 formControlName={{fControl}}
                 placeholder="{{ fControl | translate }}" />
          <mat-icon matSuffix (click)="hide = !hide">
            {{
                hide ? 'visibility_off' : 'visibility'
            }}
          </mat-icon>
        </mat-form-field>
      </div>

      <div *ngIf="title == 'changeLanguage'">
        <mat-form-field appearance="outline">
          <mat-label>{{ fControl | translate }}</mat-label>
          <mat-select formControlName="selectLanguage">
            <mat-option *ngFor="let language of languageList" [value]="language.id">
              {{ language.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions>

    <button mat-raised-button color="primary" type="submit" [disabled]="!formGroup.valid">
      {{ 'submit-btn' | translate }}
    </button>

    <button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>

  </mat-dialog-actions>
</form>
